import styled from "styled-components";

export const Container = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: var(--fixit);
  font-size: 14px;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 20px;
  border: 1px solid var(--fixit);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  
  height: 40px;

  &:hover {
    background: var(--fixit-hover-bg);
  }

  &:disabled {
    border-color: var(--light-gray);
    color: var(--light-gray);
    cursor: not-allowed;

    &:hover {
      background: transparent;
    }
  }

  .loading {
    border: 2px solid rgba(0, 0, 0, 0.1);
    border-top: 2px solid var(--fixit);
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 0.6s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
